import React from 'react';
import PropTypes from 'prop-types';
import List from "semantic-ui-react/dist/es/elements/List/List.js";
import { size } from "../../../utils/size";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { HOUSE_RULES } from "../../../utils/default-strings";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { CHECK_IN, CHECK_OUT } from "../../../utils/default-strings";
import { getCheckInAndCheckOutMarkup } from "./utils/getCheckInAndCheckOutMarkup";
export var Component = function Component(_ref) {
  var checkInTime = _ref.checkInTime,
      checkInTimeLabel = _ref.checkInTimeLabel,
      checkOutTime = _ref.checkOutTime,
      checkOutTimeLabel = _ref.checkOutTimeLabel,
      headingText = _ref.headingText,
      rules = _ref.rules;
  return React.createElement(Grid, {
    isStackable: true
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText)), size(rules) > 0 && React.createElement(GridColumn, {
    computer: 3,
    tablet: 5
  }, React.createElement(List, {
    items: rules.map(function (rule, index) {
      return React.createElement(Paragraph, {
        key: buildKeyFromStrings(rule, index)
      }, rule);
    })
  })), getCheckInAndCheckOutMarkup(checkInTimeLabel, checkInTime, checkOutTimeLabel, checkOutTime));
};
Component.displayName = 'Rules';
Component.defaultProps = {
  checkInTimeLabel: CHECK_IN,
  checkOutTimeLabel: CHECK_OUT,
  headingText: HOUSE_RULES
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  checkInTime: PropTypes.string.isRequired,
  checkInTimeLabel: PropTypes.string,
  checkOutTime: PropTypes.string.isRequired,
  checkOutTimeLabel: PropTypes.string,
  headingText: PropTypes.string,
  rules: PropTypes.arrayOf(PropTypes.string).isRequired
} : {};